import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HreflangManager = () => {
    return (
        <head>
            {/* Common meta tags */}
            <link rel="alternate" hrefLang="en" href="https://freelance-mp3-converter-v2.vercel.app/en"/>
            <link rel="alternate" hrefLang="ar" href="https://freelance-mp3-converter-v2.vercel.app/ar"/>
            <link rel="alternate" hrefLang="de" href="https://freelance-mp3-converter-v2.vercel.app/de"/>
            <link rel="alternate" hrefLang="es" href="https://freelance-mp3-converter-v2.vercel.app/es"/>
            <link rel="alternate" hrefLang="fr" href="https://freelance-mp3-converter-v2.vercel.app/fr"/>
            <link rel="alternate" hrefLang="hi" href="https://freelance-mp3-converter-v2.vercel.app/hi"/>
            <link rel="alternate" hrefLang="id" href="https://freelance-mp3-converter-v2.vercel.app/id"/>
            <link rel="alternate" hrefLang="it" href="https://freelance-mp3-converter-v2.vercel.app/it"/>
            <link rel="alternate" hrefLang="ja" href="https://freelance-mp3-converter-v2.vercel.app/ja"/>
            <link rel="alternate" hrefLang="pt" href="https://freelance-mp3-converter-v2.vercel.app/pt"/>
            <link rel="alternate" hrefLang="ru" href="https://freelance-mp3-converter-v2.vercel.app/ru"/>
            <link rel="alternate" hrefLang="uk" href="https://freelance-mp3-converter-v2.vercel.app/uk"/>
            <link rel="alternate" hrefLang="zh" href="https://freelance-mp3-converter-v2.vercel.app/zh"/>
        </head>
    );
};
export default HreflangManager;